import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FieldArrayType, FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { forEach as _forEach, cloneDeep as _cloneDeep} from 'lodash-es';
import { changeDescription } from "../../helpers/helpers";
// import { FieldConfig } from '../../helpers/field.config';
import { testHtmlRegex } from '../../helpers/helpers';
import { ActivatedRoute } from '@angular/router';
import { StudioFormInputElementTypes } from '../../../connector-studio/models/inputElementTypes.model';
export class MyCustomFieldArrayType extends FieldType {
  data: {};
}

@Component({
  selector: 'app-accordion-type',
  templateUrl: './accordion-type.component.html',
  styleUrls: ['./accordion-type.component.scss']
})
export class AccordionTypeComponent
  extends MyCustomFieldArrayType
  implements OnInit
{
  isHtml : boolean = false;
  isTemplate: boolean  = false;


 
  ngOnInit() {
    this.isHtml = testHtmlRegex(this.props.description);
  }

  defaultOptions = {
    defaultValue: {},
  };

  /**
   * Callback to invoke when an active tab is collapsed by clicking on the header.
   * @param $event Tabview event
   */
  onClose(event) {
    if (this.props.onClose) {
      this.props.onClose(event);
    }
  }

  /**
   * Callback to invoke when a tab gets expanded.
   * @param $event Tabview event
   */
  onOpen(event) {
    if (this.props.onOpen) {
      this.props.onOpen(event);
    }
  }

  addFieldForStepBuilder(event) {
    event.stopPropagation();
    const data = _cloneDeep(StudioFormInputElementTypes[8])
  }
}